import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { components } from '@glowforge/ui-common';

const { Markdown } = components;

const ReferralError = (props) => {
  const errorMessage = _.find(props.errorStrings, { fields: { id: props.status } });
  const errorTitle = _.get(errorMessage, 'fields.title') || 'Unknown Error';
  return (
    <div className='ReferralPaymentPage contentPage'>
      <h1 className='h1'>{errorTitle}</h1>
      <Markdown className='paragraph content' source={_.get(errorMessage, 'fields.text')} />
    </div>
  );
};

ReferralError.propTypes = {
  status: PropTypes.string.isRequired,
  errorStrings: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default ReferralError;



// WEBPACK FOOTER //
// ./app/components/support/referral/error.jsx